/** @jsx jsx */
import { jsx, Box } from 'theme-ui';
import React, { FunctionComponent } from 'react';
import IframeResizer from 'iframe-resizer-react';

// Types
import { CTA } from '../../@types/cta';

// Components
import Text, { TEXT_TYPES } from '../text';
import CTAButton from '../ctaButton';

// Styles
import * as baseStyle from './style';
import usePardotUrl from '../../hooks/usePardotUrl';

export interface LineFormProps {
  text: string;
  cta: CTA;
  pardotForm?: {
    pardotEmbedUrl?: string;
  };
}

const LineForm: FunctionComponent<LineFormProps> = React.memo(
  ({ text, cta, pardotForm }) => {
    const id = React.useMemo(
      () => `kenna-pardot-form-${Math.round(Math.random() * 1000)}`,
      [],
    );

    const pardotUrl = usePardotUrl(pardotForm?.pardotEmbedUrl);

    return (
      <Box sx={baseStyle.CenteredContainer}>
        <Text
          className="line-form-text"
          type={TEXT_TYPES.CTA_2}
          sx={baseStyle.StyledText}
        >
          {text}
        </Text>
        {pardotUrl && (
          <IframeResizer
            id={id}
            title={text}
            src={pardotUrl}
            frameBorder="0"
            allowtransparency="true"
            sx={baseStyle.StyledIframe}
          />
        )}
        {(!!cta.url || !!cta.pageSelector) && (
          <Box>
            <CTAButton cta={cta} type="link">
              {cta?.label}
            </CTAButton>
          </Box>
        )}
      </Box>
    );
  },
);

export default LineForm;
